var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_341_15729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.53735 2.57458H2.34583H8.8136",
    stroke: "#2FE5A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55841 2.57458V1.76611C3.55841 1.55169 3.64359 1.34606 3.79521 1.19444C3.94682 1.04282 4.15246 0.957642 4.36688 0.957642H5.98383C6.19825 0.957642 6.40388 1.04282 6.5555 1.19444C6.70712 1.34606 6.7923 1.55169 6.7923 1.76611V2.57458M8.005 2.57458V8.23389C8.005 8.44831 7.91983 8.65394 7.76821 8.80556C7.61659 8.95718 7.41095 9.04236 7.19653 9.04236H3.15417C2.93975 9.04236 2.73412 8.95718 2.5825 8.80556C2.43088 8.65394 2.3457 8.44831 2.3457 8.23389V2.57458H8.005Z",
    stroke: "#2FE5A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36694 4.59576V7.02118",
    stroke: "#2FE5A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98389 4.59576V7.02118",
    stroke: "#2FE5A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_341_15729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.70166,
    height: 9.70166,
    fill: "white",
    transform: "translate(0.324585 0.14917)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/trash-2.962f933d90a47c7577f84172514b0d0a.svg";
export { ForwardRef as ReactComponent };